// ======================================================================
// 📁 File: EquipmentDetailsDrawer.jsx
// MODULE: PPE → Engineering → Equipment Master
// ======================================================================

import React from "react";

export default function EquipmentDetailsDrawer({
  open,
  equipment,
  onClose,
}) {
  if (!open || !equipment) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        width: 520,
        height: "100vh",
        background: "#fff",
        boxShadow:
          "-4px 0 16px rgba(0,0,0,0.15)",
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ====================================================== */}
      {/* Header */}
      {/* ====================================================== */}
      <div
        style={{
          padding: 16,
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h6 style={{ margin: 0 }}>
          Equipment Details
        </h6>

        <button
          className="btn btn-sm btn-light"
          onClick={onClose}
        >
          ✕
        </button>
      </div>

      {/* ====================================================== */}
      {/* Body */}
      {/* ====================================================== */}
      <div
        style={{
          padding: 16,
          flex: 1,
          overflowY: "auto",
        }}
      >

        {/* ================================================== */}
        {/* Equipment Information */}
        {/* ================================================== */}
        <div className="card mb-3">
          <div className="card-header">
            Equipment Information
          </div>

          <div className="card-body">

            <table className="table table-sm mb-0">
              <tbody>

                <tr>
                  <th width="180">
                    Equipment Code
                  </th>
                  <td>
                    {equipment.equipment_code || "-"}
                  </td>
                </tr>

                <tr>
                  <th>
                    Equipment Name
                  </th>
                  <td>
                    {equipment.equipment_name || "-"}
                  </td>
                </tr>

                <tr>
                  <th>
                    Category
                  </th>
                  <td>
                    {equipment.equipment_category || "-"}
                  </td>
                </tr>

                <tr>
                  <th>
                    Status
                  </th>
                  <td>
                    <span
                      className={`badge ${
                        equipment.is_active
                          ? "bg-success"
                          : "bg-secondary"
                      }`}
                    >
                      {equipment.is_active
                        ? "Active"
                        : "Inactive"}
                    </span>
                  </td>
                </tr>

              </tbody>
            </table>

          </div>
        </div>

        {/* ================================================== */}
        {/* Engineering Association */}
        {/* ================================================== */}
        <div className="card mb-3">
          <div className="card-header">
            Engineering Association
          </div>

          <div className="card-body">

            <table className="table table-sm mb-0">
              <tbody>

                <tr>
                  <th width="180">
                    Product Family
                  </th>
                  <td>
                    {equipment.product_family_name || "-"}
                  </td>
                </tr>

                <tr>
                  <th>
                    Product Variant
                  </th>
                  <td>
                    {equipment.product_variant_name || "-"}
                  </td>
                </tr>

              </tbody>
            </table>

          </div>
        </div>

        {/* ================================================== */}
        {/* Description */}
        {/* ================================================== */}
        <div className="card mb-3">
          <div className="card-header">
            Description
          </div>

          <div className="card-body">

            <div
              style={{
                whiteSpace: "pre-wrap",
                minHeight: 80,
              }}
            >
              {equipment.description || "-"}
            </div>

          </div>
        </div>

        {/* ================================================== */}
        {/* Audit Information */}
        {/* ================================================== */}
        <div className="card">
          <div className="card-header">
            Audit Information
          </div>

          <div className="card-body">

            <table className="table table-sm mb-0">
              <tbody>

                <tr>
                  <th width="180">
                    Created By
                  </th>
                  <td>
                    {equipment.created_by || "-"}
                  </td>
                </tr>

                <tr>
                  <th>
                    Created At
                  </th>
                  <td>
                    {equipment.created_at || "-"}
                  </td>
                </tr>

                <tr>
                  <th>
                    Updated By
                  </th>
                  <td>
                    {equipment.updated_by || "-"}
                  </td>
                </tr>

                <tr>
                  <th>
                    Updated At
                  </th>
                  <td>
                    {equipment.updated_at || "-"}
                  </td>
                </tr>

              </tbody>
            </table>

          </div>
        </div>

      </div>

      {/* ====================================================== */}
      {/* Footer */}
      {/* ====================================================== */}
      <div
        style={{
          padding: 16,
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          className="btn btn-outline-secondary"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
}